export const ADD_TEXT = 'add-text';
export const SET_PREDEFINED_TEXT = 'set-predefined-text';
export const FILL_SIGN_ADD_TICK = 'fill-sign-add-tick';
export const FILL_SIGN_ADD_CROSS = 'fill-sign-add-cross';
export const FILL_SIGN_ADD_LINE = 'fill-sign-add-line';
export const FILL_SIGN_ADD_DOT = 'fill-sign-add-dot';
export const FILL_SIGN_ADD_RECTANGLE = 'fill-sign-add-rectangle';
export const REQUEST_SIGNATURE = 'request-signature';
export const AGREEMENT_STATUS = 'agreement-status';
export const MANAGE_SIGNATURE = 'manage-signature';
export const USE_FOXIT_SIGN = 'use-foxit-sign';
export const CREATE_SIGNATURE = 'create-signature';
export const APPLY_ALL_SIGNATURE = 'apply-all-signature';
export const DOCUMENT_STATUS = 'document-status';
export const CLOSE_SIGN = 'close-sign';
export const FX_ESIGN_SWITCH_BTN = 'fx-esign-switch-btn';
export const FILL_SIGN_BUTTON= 'fill-sign-button';
export const FILL_SIGN_BUTTON_HOME= 'fill-sign-button_home';
export const SWITCH_ACCOUNTS = 'switch-accounts'


export const FILL_SIGN_LIST = [
  ADD_TEXT,
  SET_PREDEFINED_TEXT,
  FILL_SIGN_ADD_TICK,
  FILL_SIGN_ADD_CROSS,
  FILL_SIGN_ADD_LINE,
  FILL_SIGN_ADD_DOT,
  FILL_SIGN_ADD_RECTANGLE
]

export const Fill_Sign_MAP = {
  RequestSignature: {
    name: REQUEST_SIGNATURE,
    title: 'phantom_online:toolbar.fillAndSign.RequestSignature.title',
    icon: 'fv__icon-toolbar-request-signature',
    tooltip: 'phantom_online:toolbar.fillAndSign.RequestSignature.tooltip',
    tooltipDes: 'phantom_online:toolbar.fillAndSign.RequestSignature.tooltipDes',
  },
  AgreementStatus: {
    name: AGREEMENT_STATUS,
    title: 'phantom_online:toolbar.fillAndSign.AgreementStatus.title',
    icon: 'fv__icon-toolbar-agreement-status',
    tooltip: 'phantom_online:toolbar.fillAndSign.AgreementStatus.tooltip',
  },
  ManageSignature: {
    name: MANAGE_SIGNATURE,
    title: 'phantom_online:toolbar.fillAndSign.ManageSignature.title',
    icon: 'fv__icon-toolbar-manage_signature',
    tooltip: 'phantom_online:toolbar.fillAndSign.ManageSignature.tooltip',
    tooltipDes: 'phantom_online:toolbar.fillAndSign.ManageSignature.tooltipDes',
  },
  ApplyAllSignature: {
    name: APPLY_ALL_SIGNATURE,
    title: 'phantom_online:toolbar.fillAndSign.ApplyAllSignature.title',
    icon: 'fv__icon-toolbar-apply_all_signature',
    tooltip: 'phantom_online:toolbar.fillAndSign.ApplyAllSignature.tooltip',
    tooltipDes: 'phantom_online:toolbar.fillAndSign.ApplyAllSignature.tooltipDes',
    tipContent: 'phantom_online:toolbar.fillAndSign.ApplyAllSignature.tipContent',
  },
  DocumentStatus: {
    name: DOCUMENT_STATUS,
    title: 'phantom_online:toolbar.fillAndSign.DocumentStatus.title',
    icon: 'fv__icon-toolbar-document_status',
    tooltip: 'phantom_online:toolbar.fillAndSign.DocumentStatus.tooltip',
    tooltipDes: 'phantom_online:toolbar.fillAndSign.ApplyAllSignature.tooltipDes',
  },
  CloseSign: {
    name: CLOSE_SIGN,
    title: 'phantom_online:toolbar.fillAndSign.CloseSign.title',
    icon: 'fv__icon-toolbar-close_sign',
    tooltip: 'phantom_online:toolbar.fillAndSign.CloseSign.tooltip',
  },
  ProtectPdfSign: {
    name: FILL_SIGN_BUTTON,
    title: 'phantom_online:toolbar.fillAndSign.PDFSign.title',
    icon: 'fv__icon-toolbar-inksign',
    tooltip: 'phantom_online:toolbar.fillAndSign.PDFSign.tooltip',
  },
  HomePdfSign: {
    name: FILL_SIGN_BUTTON_HOME,
    title: 'phantom_online:toolbar.fillAndSign.PDFSign.title',
    icon: 'fv__icon-toolbar-inksign',
    tooltip: 'phantom_online:toolbar.fillAndSign.PDFSign.tooltip',
  },

};
export const foxitSignSupportSuffix = ['.doc', '.docx', '.htm', '.html', '.jpeg', '.jpg', '.odt', '.pdf', '.png', '.rtf', '.tif', '.tiff'];
